// extracted by mini-css-extract-plugin
export var b_icon = "styles-module--b_icon--b5Amh";
export var blink = "styles-module--blink--u0bU9";